import { createContext } from 'react';

export const DeleteBankAccountModalContext = createContext(null);
